<template>
    <div
      class="pageSmallCard listItem"
      :class="{
        isUsed: itemData.withdrawStatus == 1 || itemData.withdrawStatus == 3,
      }"
    >
      <div>
        <div class="pageFlexBetween title">
          <p>
            No.{{ itemData.withdrawNo }}
          </p>
          <span class="pageFontWeight"
            >{{ $formatMoney(itemData.withdrawBalance, 1) }}元</span
          >
        </div>
        <div class="line"></div>
        <div class="detail">
          <div class="pageFlexColumn icons">
            <div class="pageBgBlock">
              <i class="iconfont icondingdan1"></i>
            </div>
            <p :class="'pageDefaultRadius '">
              {{ itemData.orderStatusText }}
            </p>
          </div>
          <div v-if="show" class="list">
            <li v-if="itemData.withdrawCardNo">卡券编号：{{ itemData.withdrawCardNo }}</li>
            <li v-if="itemData.withdrawAccountHolder">
              账户名称：{{ itemData.withdrawAccountHolder }}
            </li>
            <li v-if="itemData.withdrawAccount">
              提现账户：{{ itemData.withdrawAccount.replace(/(\d{4})(?=\d)/g, '$1  ') }}
            </li>
            <li>提现时间：{{ itemData.withdrawCreateTime.replace(/(T)/g, ' ') }}</li>
            <li v-if="itemData.withdrawRemark">
              提现备注：{{ optimizeMsg(itemData.withdrawRemark) }}
            </li>
          </div>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  import { repay } from "api/submit";
  import { wechatPay } from "api/wechatSDK";
  import { cancelOrder } from "api/submit";
  import { getCardPwdInfo } from "api/onLine";
  
  export default {
    props: {
      itemData: {
        type: Object,
        default: () => ({}),
      },
      show: {
        type: Boolean,
        default: () => true,
      },
    },
    data() {
      return {
        html: "",
        orderStatus: "",
        cardInfoShow: false,
        cardInfo: [],
      };
    },
    created() {},
    mounted() {},
    methods: {
      cancelClick(id) {
        this.$confirm("取消后不可恢复，确认要取消订单吗？", "确认提示", "#EE0A24")
          .then(() => {
            this.$loading("取消中");
            cancelOrder(id).then((res) => {
              this.$clear();
              if (res.status === 200) {
                this.$successSync("订单取消成功", () => {
                  this.$parent.$parent.$parent.$parent.$parent.currentPages = 1;
                  this.$parent.$parent.$parent.$parent.$parent.len = 0;
                  this.$parent.$parent.$parent.$parent.$parent.finished = false;
                  this.$parent.$parent.$parent.$parent.$parent.loading = true;
                  this.$parent.$parent.$parent.$parent.$parent.onLoad();
                });
              } else {
                this.$error(res.message);
              }
            });
          })
          .catch(() => {
            // on cancel
          });
      },
      payNow(id) {
        this.$loading("支付中");
        repay(id).then((res) => {
          if (res.status === 200) {
            if ((typeof res.data == "object") & (res.data != null)) {
              if (res.data.appId != undefined) {
                wechatPay(res.data);
              }
            } else {
              this.$error(res.message);
            }
          } else {
            this.$error(res.message);
          }
        });
      },
      getIcon(type) {
        let arry = { icon: "", color: "" };
        switch (type) {
          //退款、余额充值、线下服务
          case 1:
          case 3:
            arry.icon = "icondingdan1";
            break;
          //油卡、加油广东
          case 4:
          case 13:
            arry.icon = "iconjiayouqia";
            break;
          //话费流量
          case 5:
          case 6:
            arry.icon = "iconu1053";
            break;
          //购物卡
          case 7:
            arry.icon = "iconqiapian";
            break;
          //视频、音乐、游戏充值
          case 8:
            arry.icon = "iconziyuan1";
            break;
          case 9:
            arry.icon = "iconu1081";
            break;
          case 10:
            arry.icon = "iconyouxi";
            break;
          //卡券购买
          case 2:
          case 11:
            arry.icon = "iconquan";
            break;
          //转让订单
          case 12:
            arry.icon = "iconzhuanrangzhuangtai";
            break;
          //健康档案、家医保、健康体检
          case 14:
            arry.icon = "iconjiankangdangan";
            break;
          case 15:
            arry.icon = "iconhuiyuan";
            break;
          //加油兑换券
          case 16:
            arry.icon = "iconjixuduihuan";
            break;
          case 17:
            arry.icon = "iconnianshendaoqitixing";
            break;
          case 18:
            arry.icon = "icondrive";
            break;
        }
        return arry;
      },
      pwdHandle(orderId) {
        getCardPwdInfo(orderId).then((res) => {
          if (res.status === 200) {
            this.cardInfo = res.data;
            this.cardInfoShow = true;
          } else {
            this.$error(res.message);
          }
        });
      },
      copyHandle(type) {
        let text;
        if (type === 1) {
          text = this.cardInfo.cardNo;
        } else if (type === 2) {
          text = this.cardInfo.cardPwd;
        } else {
          return;
        }
        this.$copyText(text).then(
          () => {
            this.$success("复制成功");
          },
          () => {
            this.$error("复制失败");
          }
        );
      },
      watchVideo(videoOrderId) {
        this.$push({
          path: `/showVideo?videoOrderId=${videoOrderId}`,
        });
      },
      optimizeMsg(message) {
        if (message.includes('打款手续费未设置')) {
          return '~'
        } 
        return message
      }
    },
  };
  </script>
  
  <style scoped lang="less">
  @themeColor: #fff;
  .listItem {
    width: 100%;
    padding: 0;
    margin-top: 15px;
    min-height: 90px;
    font-size: var(--pFont);
    .goUrl {
      .van-divider {
        margin: 0px;
      }
      .van-cell__title,
      .van-cell__value {
        flex: initial;
      }
      .url {
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-radius: 5px;
        .van-cell__title {
          width: 80%;
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
      }
    }
    .title {
      // height: 40px;
      padding: 10px 0;
      font-size: var(--titleFont);
      color: var(--titleColor);
      p {
        // margin-left: 24%;
        margin-left: 10px;
        font-family: 'Arial Negreta', 'Arial Normal', 'Arial', sans-serif;
        font-size: 15px;
        font-weight: 600;
      }
      span {
        color: var(--redColor);
        margin-right: 13px;
        max-width: 95px;
        min-width: 50px;
        text-align: right;
      }
    }
    .line {
      height: 5px;
      margin: 0 2px;
      margin-top: -5px;
      box-shadow: 0px 4px 4px 2px #f4f4f4;
    }
    .unPay {
      p {
        color: var(--greenColor);
        background: #eef6e0;
      }
    }
    .processing {
      p {
        background: #fdecd5;
        color: var(--depYelColor);
      }
    }
    .detail {
      padding: 12px 0;
      display: flex;
      .icons {
        width: 19%;
        color: #666;
        margin: 0 10px;
        display: inline-flex;
        vertical-align: top;
        // margin-top: -40px;
        .pageBgBlock {
          color: #fff;
          width: 50px;
          height: 50px;
          background: var(--redColor);
          margin-bottom: 4px;
          .iconfont {
            font-size: 28px;
            margin: 4px 10px;
          }
        }
        p {
          margin-top: 5px;
          padding: 5px 8px;
          font-size: var(--spanFont);
          color: var(--depBlueColor);
          background: #e0f4fd;
        }
        .pay {
          background: #eef6e0;
          color: #70b603;
        }
        .handle {
          background: #fdecd5;
          color: #ff3300;
        }
        .cancel {
          background: #fefefe;
          color: #000;
        }
      }
      .details {
        width: 73%;
        display: inline-block;
        line-height: 1.5;
        padding-bottom: 15px;
        li {
          font-size: var(--smallFont);
          color: #555555;
          word-break: break-all;
        }
      }
      .list {
        width: 66%;
        font-size: var(--smallFont);
        color: var(--hidColor) !important;
        display: inline-block;
        line-height: 1.8;
        li {
          word-break: break-all;
        }
      }
      .remark {
        margin-top: 5px;
        padding-top: 4px;
        font-size: var(--pFont);
        border-top: 1px solid var(--lineColor);
        color: var(--hidColor);
      }
      h5 {
        margin-top: 6px;
        color: var(--depBlueColor);
      }
    }
    .btnGroud {
      .pageSmallBtns {
        width: 50%;
        height: 40px;
        border-radius: 0px;
      }
      .btnBig {
        width: 100% !important;
      }
      .cancel {
        color: var(--depHidColor) !important;
      }
    }
    .showPwd {
      padding: 20px 10px 0;
      p {
        margin-bottom: 20px;
      }
    }
    .footer {
      color: #fff;
      background: var(--depBlueColor);
      height: 35px;
      padding: 0 15px;
      box-sizing: border-box;
      p {
        flex: 1;
      }
      .pageSmallBtns {
        color: var(--depBlueColor) !important;
        border-radius: 5px;
        font-size: var(--spanFont);
        height: 24px;
      }
    }
  }
  .isUsed {
    background: var(--bgColor);
    position: relative;
    border: 1px solid #fff;
    &::after {
      content: "";
      position: absolute;
      top: 0;
      left: 0;
      right: 0;
      bottom: 0;
      background: rgba(249, 249, 249, 0.5);
    }
  }
  </style>
  